import { useMemo } from "react";
import { useLocation } from "react-router-dom";

export type MobileHeaderContext = "home" | "chat" | "commerce" | "other";

/**
 * Mobil header'ın hangi bağlamda olduğunu tek yerden hesaplar.
 *
 * GlobalHeader (sağ ikon seti) ve MobileBreadcrumbBar (header altı şerit)
 * aynı karara bakar; ikisinin ayrışmaması için burada tutulur.
 */
export const useMobileHeaderContext = () => {
  const { pathname } = useLocation();

  const isChatPage = pathname.startsWith("/chat/");
  // 🆕 /new-chat: eski chat ana ekranı da "home" bağlamında davranır
  const isHomePage = pathname === "/" || pathname === "/new-chat";
  const isOrdersPage = pathname.startsWith("/orders");
  const isCartPage = pathname === "/cart";
  const isCheckoutPage = pathname === "/checkout";
  const isCommercePage = isOrdersPage || isCartPage || isCheckoutPage;

  const mobileContext = useMemo<MobileHeaderContext>(() => {
    if (isHomePage) return "home";
    if (isChatPage) return "chat";
    if (isCommercePage) return "commerce";
    return "other";
  }, [isHomePage, isChatPage, isCommercePage]);

  return {
    mobileContext,
    isChatPage,
    isHomePage,
    isOrdersPage,
    isCartPage,
    isCheckoutPage,
    isCommercePage,
  };
};
